export default "__VITE_ASSET__BnrLwX7t__"